import React, { useCallback, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  faFileInvoice,
  faReceipt,
  faTasks,
  faCirclePlus,
  faEnvelope,
  faCartPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OutsideClickHandler from "react-outside-click-handler";

import UserNavbar from "../UserNavbar";
import UserFooter from "../UserFooter";
import MainSidebar from "../Mainsidebar";
import CustomerDetails from "./CustomerDetails";
import Data_Table from "./Data_Table";

import "../../Style/LandingPage.css";
import { Avatar } from "@mui/material";
import defaultAvatar from "../../Images/default-avatar.svg";
import bb3 from "../../Images/bb3.jpg";
import { path_url } from "../../Config/config";
import VendorProfileCard from "../components/VendorProfileCard";
import QuickEmailModal from "../components/QuickEmailModal";
import CreateServiceRequestModal from "../components/CreateServiceRequestModal";
import CreatePurchaseModal from "../components/CreatePurchaseModal";
import CreateProformaModal from "../components/CreateProformaModal";
import CreateInteractionRecordModal from "../components/CreateInteractionRecordModal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function CustomerDetailsParent() {
  const { id } = useParams();
  const navigate = useNavigate();

  /* ---------- State ---------- */
  const [showComponent, setShowComponent] = useState(false);
  const [hamburger, sethamburger] = useState(false);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);
  const [profile, setProfile] = useState({});
  const [Details, setDetails] = useState({});
  const [showMobileButtons, setShowMobileButtons] = useState(true);

  // Individual dropdown states to prevent conflicts
  const [dropdownStates, setDropdownStates] = useState({
    invoice: false,
    purchase: false,
    proforma: false,
    task: false,
    service: false,
    sendMail: false,
    contact: false,
  });

  const closeAllDropdowns = () => {
    setDropdownStates({
      invoice: false,
      purchase: false,
      proforma: false,
      task: false,
      service: false,
      sendMail: false,
      contact: false,
    });
  };

  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [showProformaModal, setShowProformaModal] = useState(false);
  const [showInteractionModal, setShowInteractionModal] = useState(false);

  // Column visibility states (kept for potential use)
  const [Id, setId] = useState(true);
  const [Subject, setSubject] = useState(true);
  const [Status, setStatus] = useState(true);
  const [Duedate, setDuedate] = useState(true);
  const [Assigned, setAssigned] = useState(true);
  const [Priority, setPriority] = useState(true);
  const [Type, setType] = useState(true);

  /* ---------- Handlers ---------- */
  const handleID = () => setId(!Id);
  const handleSubject = () => setSubject(!Subject);
  const handleStatus = () => setStatus(!Status);
  const handlePriority = () => setPriority(!Priority);
  const handleAssigned = () => setAssigned(!Assigned);
  const handleType = () => setType(!Type);
  const handleDuedate = () => setDuedate(!Duedate);
  const handleToggle = () => setShowComponent(!showComponent);

  // Dropdown toggle functions — close all others before toggling
  const toggleDropdown = (dropdownName) => {
    setDropdownStates((prev) => {
      const allClosed = Object.keys(prev).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {});
      return {
        ...allClosed,
        [dropdownName]: !prev[dropdownName],
      };
    });
  };

  const handleAction = (type, path) => {
    toggleDropdown(type);
    navigate(path, { state: { customerId: id, customerData: profile } });
  };

  const handleScrollTo = (type, sectionId) => {
    toggleDropdown(type);
    const el = document.getElementById(sectionId);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };

  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };

  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);

  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { width: "100%", left: "0rem" };
    }
    return {
      width: !hamburger && "-webkit-fill-available",
      left: !hamburger && "3.7rem",
    };
  };

  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
    return {};
  };

  const handleMobileButtonClick = () => {
    setShowMobileButtons(!showMobileButtons);
  };

  /* ---------- Data fetch ---------- */
  const fetchdetails = useCallback(async () => {
    const token = localStorage.getItem("accessToken");
    try {
      const response = await axios.get(`${path_url}/customer/details/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      setDetails(response.data.body);
      setProfile(response.data.body.customer);
      // Publish page context for any global listeners
      window.__CRM_PAGE_CONTEXT__ = {
        type: "customer",
        profile: response.data.body.customer,
        details: response.data.body,
      };
      window.dispatchEvent(new CustomEvent("crm-context-updated"));
    } catch (error) {
      console.error("Failed to fetch customer details:", error);
    }
  }, [id]);

  useEffect(() => {
    fetchdetails();
    return () => {
      window.__CRM_PAGE_CONTEXT__ = null;
      window.dispatchEvent(new CustomEvent("crm-context-updated"));
    };
  }, [fetchdetails]);

  /* ---------- Render ---------- */
  return (
    <>
      <div className="con1 d-flex">
        {/* Sidebar */}
        <div className="subcon1" style={handleclickonbutton1(hamburger)}>
          <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
        </div>

        {/* Main content */}
        <div className="subcon2" style={handleclickonbutton(hamburger)}>
          <UserNavbar
            hamburger={hamburger}
            sethamburger={sethamburger}
            handelRightMenuShow={handelRightMenuShow}
            handelShow={handelShow}
            isSearchShow={isSearchShow}
            handleScreenEnter={handleScreenEnter}
            handleScreenExit={handleScreenExit}
            fullScreen={fullScreen}
          />
          <div>
            {/* Header image & avatar */}
            <div
              className="col-12 w-9 d-flex justify-content-center"
              style={{ paddingTop: 5, position: "relative" }}
            >
              <img
                src={bb3}
                alt=""
                style={{
                  width: "100%",
                  height: "5rem",
                  objectFit: "cover",
                  backgroundPosition: "center",
                }}
              />
              <Avatar
                src={defaultAvatar}
                className="my-5"
                style={{
                  position: "absolute",
                  left: "51%",
                  transform: "translateX(-50%)",
                  zIndex: 3,
                  width: "6rem",
                  height: "6rem",
                  border: "3px solid #ffffff",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                  backgroundColor: "#e2e8f0",
                }}
              />
            </div>

            {/* Title & breadcrumb */}
            <div className="col-12 justify-content-center">
              <div
                className="row justify-content-center"
                style={{ marginTop: "3.3rem" }}
              >
                <div className="content-header">
                  <div className="content-fluid">
                    <div className="row mt-3">
                      <div className="col-sm-6">
                        <h4>Customer Details</h4>
                      </div>
                      <div className="col-sm-6">
                        <ul className="breadcrumb float-sm-right mb-4">
                          <li className="breadcrumb-item">
                            <a href="#">Home</a>
                          </li>
                          <li className="breadcrumb-item">General Form</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Action buttons row */}
                <div className="col-12 bg-white">
                  <div className="col-12 mt-2">
                    <div
                      className="mt-2"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        gap: "0.5rem",
                      }}
                    >
                      {/* Mobile show/hide button */}
                      {document.documentElement.clientWidth <= 768 && (
                        <button
                          className="btn btn-md bg-gradient-primary"
                          style={{
                            background:
                              "#007bff linear-gradient(180deg,#268fff,#007bff) repeat-x",
                            color: "#fff",
                            display: "flex",
                            gap: "0.5rem",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "1.2rem",
                            margin: "0 auto",
                          }}
                          onClick={handleMobileButtonClick}
                        >
                          {showMobileButtons ? "Hide" : "Show"} Buttons
                        </button>
                      )}

                      {/* Button groups – rendered only when visible */}
                      {showMobileButtons && (
                        <>
                          {/* ==== Invoice ==== */}
                          <OutsideClickHandler
                            onOutsideClick={() => {
                              setDropdownStates((prev) => ({
                                ...prev,
                                invoice: false,
                              }));
                            }}
                          >
                            <button
                              className="btn bg-gradient-primary dropdown-toggle"
                              style={{
                                background: "rgb(227, 233, 237) repeat-x",
                                color: "black",
                                display: "flex",
                                gap: "0.5rem",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "1.0rem",
                                fontSize: "small",
                                height: "40px",
                                width: "100px",
                                flexShrink: 0,
                              }}
                              onClick={() => toggleDropdown("invoice")}
                            >
                              Invoice
                            </button>
                            <div
                              className={`dropdown-menu ${dropdownStates.invoice ? "show" : ""
                                } dropdown-menu-end`}
                              aria-labelledby="dropdownMenuButton"
                            >
                              <div
                                className="dropdown-item"
                                onClick={() => {
                                  closeAllDropdowns();
                                  navigate("/create-invoice", {
                                    state: { customerId: id, customer: profile },
                                  });
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <FontAwesomeIcon icon={faFileInvoice} /> Create Invoice
                              </div>
                              <div
                                className="dropdown-item"
                                onClick={() => {
                                  closeAllDropdowns();
                                  document
                                    .getElementById("customer-invoice-section")
                                    ?.scrollIntoView({ behavior: "smooth" });
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <FontAwesomeIcon icon={faReceipt} /> View Invoice
                              </div>
                              <div
                                className="dropdown-item"
                                onClick={() => {
                                  closeAllDropdowns();
                                  navigate("/create-task");
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <img
                                  src="/assets/Create_task.png"
                                  alt="create task"
                                  style={{
                                    height: "25px",
                                    width: "17px",
                                    marginLeft: "-3px",
                                  }}
                                />{" "}
                                Create Task
                              </div>
                              <div
                                className="dropdown-item"
                                onClick={() => {
                                  closeAllDropdowns();
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <FontAwesomeIcon icon={faTasks} /> View Task
                              </div>
                            </div>
                          </OutsideClickHandler>

                          {/* ==== Purchase ==== */}
                          <OutsideClickHandler
                            onOutsideClick={() => {
                              setDropdownStates((prev) => ({
                                ...prev,
                                purchase: false,
                              }));
                            }}
                          >
                            <button
                              className="btn bg-gradient-primary dropdown-toggle"
                              style={{
                                background: "rgb(227, 233, 237) repeat-x",
                                color: "black",
                                display: "flex",
                                gap: "0.5rem",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "1.0rem",
                                fontSize: "small",
                                height: "40px",
                                width: "100px",
                                flexShrink: 0,
                              }}
                              onClick={() => toggleDropdown("purchase")}
                            >
                              Purchase
                            </button>
                            <div
                              className={`dropdown-menu ${dropdownStates.purchase ? "show" : ""
                                } dropdown-menu-end`}
                              aria-labelledby="dropdownMenuButton"
                            >
                              <div
                                className="dropdown-item"
                                onClick={() => {
                                  closeAllDropdowns();
                                  navigate("/create-purchase-order", {
                                    state: { customerId: id, customer: profile },
                                  });
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <FontAwesomeIcon icon={faFileInvoice} /> Create Purchase Order
                              </div>
                              <div
                                className="dropdown-item"
                                onClick={() => {
                                  closeAllDropdowns();
                                  document
                                    .getElementById("customer-purchase-section")
                                    ?.scrollIntoView({ behavior: "smooth" });
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <FontAwesomeIcon icon={faReceipt} /> View Purchase Order
                              </div>
                              <div
                                className="dropdown-item"
                                onClick={() => {
                                  closeAllDropdowns();
                                  navigate("/create-task");
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <img
                                  src="/assets/Create_task.png"
                                  alt="create task"
                                  style={{
                                    height: "25px",
                                    width: "17px",
                                    marginLeft: "-3px",
                                  }}
                                />{" "}
                                Create Task
                              </div>
                              <div
                                className="dropdown-item"
                                onClick={() => {
                                  closeAllDropdowns();
                                }}
                                style={{ cursor: "pointer" }}
                              >
                                <FontAwesomeIcon icon={faTasks} /> View Task
                              </div>
                            </div>
                          </OutsideClickHandler>

                          {/* ==== Proforma ==== */}
                          <OutsideClickHandler
                            onOutsideClick={() => {
                              setDropdownStates((prev) => ({
                                ...prev,
                                proforma: false,
                              }));
                            }}
                          >
                            <button
                              className="btn bg-gradient-primary dropdown-toggle"
                              style={{
                                background: "rgb(227, 233, 237) repeat-x",
                                color: "black",
                                display: "flex",
                                gap: "0.5rem",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "1.0rem",
                                fontSize: "small",
                                height: "40px",
                                width: "100px",
                                flexShrink: 0,
                              }}
                              onClick={() => toggleDropdown("proforma")}
                            >
                              Proforma
                            </button>
                            <div
                              className={`dropdown-menu ${dropdownStates.proforma ? "show" : ""
                                } dropdown-menu-end`}
                              aria-labelledby="dropdownMenuButton"
                            >
                              <div
                                className="dropdown-item"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  toggleDropdown("proforma");
                                  setShowProformaModal(true);
                                }}
                              >
                                <FontAwesomeIcon icon={faFileInvoice} /> Create
                                Proforma
                              </div>
                              <div
                                className="dropdown-item"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleScrollTo("proforma", "proforma-section")
                                }
                              >
                                <FontAwesomeIcon icon={faReceipt} /> View
                                Proforma
                              </div>
                            </div>
                          </OutsideClickHandler>

                          {/* ==== Task ==== */}
                          <OutsideClickHandler
                            onOutsideClick={() => {
                              setDropdownStates((prev) => ({
                                ...prev,
                                task: false,
                              }));
                            }}
                          >
                            <button
                              className="btn bg-gradient-primary dropdown-toggle"
                              style={{
                                background: "rgb(227, 233, 237) repeat-x",
                                color: "black",
                                display: "flex",
                                gap: "0.5rem",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "1.0rem",
                                fontSize: "small",
                                height: "40px",
                                width: "100px",
                                flexShrink: 0,
                              }}
                              onClick={() => toggleDropdown("task")}
                            >
                              Task
                            </button>
                            <div
                              className={`dropdown-menu ${dropdownStates.task ? "show" : ""
                                } dropdown-menu-end`}
                              aria-labelledby="dropdownMenuButton"
                            >
                              <div
                                className="dropdown-item"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleAction("task", "/create-task")
                                }
                              >
                                <FontAwesomeIcon icon={faCirclePlus} /> Create
                                Task
                              </div>
                              <div
                                className="dropdown-item"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleScrollTo("task", "task-section")
                                }
                              >
                                <FontAwesomeIcon icon={faTasks} /> View Task
                              </div>
                            </div>
                          </OutsideClickHandler>

                          {/* ==== Service ==== */}
                          <OutsideClickHandler
                            onOutsideClick={() => {
                              setDropdownStates((prev) => ({
                                ...prev,
                                service: false,
                              }));
                            }}
                          >
                            <button
                              className="btn bg-gradient-primary dropdown-toggle"
                              style={{
                                background: "rgb(227, 233, 237) repeat-x",
                                color: "black",
                                display: "flex",
                                gap: "0.5rem",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "1.0rem",
                                fontSize: "small",
                                height: "40px",
                                width: "100px",
                                flexShrink: 0,
                              }}
                              onClick={() => toggleDropdown("service")}
                            >
                              Service
                            </button>
                            <div
                              className={`dropdown-menu ${dropdownStates.service ? "show" : ""
                                } dropdown-menu-end`}
                              aria-labelledby="dropdownMenuButton"
                            >
                              <div
                                className="dropdown-item"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  toggleDropdown("service");
                                  setShowServiceModal(true);
                                }}
                              >
                                <FontAwesomeIcon icon={faFileInvoice} /> Create
                                Service Request
                              </div>
                              <div
                                className="dropdown-item"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleScrollTo("service", "service-section")
                                }
                              >
                                <FontAwesomeIcon icon={faReceipt} /> View
                                Service Request
                              </div>
                            </div>
                          </OutsideClickHandler>

                          {/* ==== Send Mail ==== */}
                          <OutsideClickHandler
                            onOutsideClick={() => {
                              setDropdownStates((prev) => ({
                                ...prev,
                                sendMail: false,
                              }));
                            }}
                          >
                            <button
                              className="btn bg-gradient-primary dropdown-toggle"
                              style={{
                                background: "rgb(227, 233, 237) repeat-x",
                                color: "black",
                                display: "flex",
                                gap: "0.5rem",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "1.0rem",
                                fontSize: "small",
                                height: "40px",
                                width: "100px",
                                flexShrink: 0,
                              }}
                              onClick={() => toggleDropdown("sendMail")}
                            >
                              Send Mail
                            </button>
                            <div
                              className={`dropdown-menu ${dropdownStates.sendMail ? "show" : ""
                                } dropdown-menu-end`}
                              aria-labelledby="dropdownMenuButton"
                            >
                              <div
                                className="dropdown-item"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  toggleDropdown("sendMail");
                                  setShowEmailModal(true);
                                }}
                              >
                                <FontAwesomeIcon icon={faEnvelope} /> Send Email
                              </div>
                            </div>
                          </OutsideClickHandler>

                          {/* ==== Contact ==== */}
                          <OutsideClickHandler
                            onOutsideClick={() => {
                              setDropdownStates((prev) => ({
                                ...prev,
                                contact: false,
                              }));
                            }}
                          >
                            <button
                              className="btn bg-gradient-primary dropdown-toggle"
                              style={{
                                background: "rgb(227, 233, 237) repeat-x",
                                color: "black",
                                display: "flex",
                                gap: "0.5rem",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "1.0rem",
                                fontSize: "small",
                                height: "40px",
                                width: "100px",
                                flexShrink: 0,
                              }}
                              onClick={() => toggleDropdown("contact")}
                            >
                              Contact
                            </button>
                            <div
                              className={`dropdown-menu ${dropdownStates.contact ? "show" : ""
                                } dropdown-menu-end`}
                              aria-labelledby="dropdownMenuButton"
                            >
                              <div
                                className="dropdown-item"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleScrollTo("contact", "contact-section")
                                }
                              >
                                <FontAwesomeIcon icon={faFileInvoice} />{" "}
                                Interaction Record
                              </div>
                            </div>
                          </OutsideClickHandler>

                          {/* ==== Add Product ==== */}
                          <button
                            className="btn bg-gradient-primary"
                            style={{
                              background: "rgb(227, 233, 237) repeat-x",
                              color: "black",
                              display: "flex",
                              gap: "0.5rem",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "1.0rem",
                              fontSize: "small",
                              height: "40px",
                              width: "120px",
                              flexShrink: 0,
                              border: "none",
                            }}
                            onClick={() => navigate(`/product/${id}`)}
                          >
                            <FontAwesomeIcon icon={faCartPlus} /> Add Product
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Profile and Summary Row */}
                <div className="row customer-detail">
                  <div className="col-md-4 mt-2">
                    <div className="vendor-profile mt-2">
                      <VendorProfileCard
                        Details={profile}
                        onSendMail={() => setShowEmailModal(true)}
                      />
                    </div>
                  </div>

                  <div className="col-md-8 mt-2">
                    {/* Summary Cards */}
                    <div className="row" style={{ marginTop: "30px" }}>
                      <div className="col-md-4 mb-3">
                        <div
                          className="info-box bg-light"
                          style={{ height: "100%" }}
                        >
                          <div className="info-box-content">
                            <span className="info-box-text text-center text-muted">
                              Total Invoice
                            </span>
                            <span className="info-box-text text-center text-muted mb-0">
                              <b style={{ color: "black" }}>
                                {Details?.count?.totalInvoice ?? 0}
                              </b>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div
                          className="info-box bg-light"
                          style={{ height: "100%" }}
                        >
                          <div className="info-box-content">
                            <span className="info-box-text text-center text-muted">
                              Total Service Request
                            </span>
                            <span className="info-box-text text-center text-muted mb-0">
                              <b style={{ color: "black" }}>
                                {Details?.count?.totalServiceRequets ?? 0}
                              </b>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 mb-3">
                        <div
                          className="info-box bg-light"
                          style={{ height: "100%" }}
                        >
                          <div className="info-box-content">
                            <span className="info-box-text text-center text-muted">
                              Total Order
                            </span>
                            <span className="info-box-text text-center text-muted mb-0">
                              <b style={{ color: "black" }}>
                                {Details?.count?.totalOrders ?? 0}
                              </b>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Data Tables */}
                    {Details?.dueToday?.length > 0 && (
                      <Data_Table
                        tableData={Details.dueToday}
                        title="Due Today"
                      />
                    )}
                    {Details?.overdue?.length > 0 && (
                      <Data_Table tableData={Details.overdue} title="Overdue" />
                    )}
                    {Details?.openItemsList?.length > 0 && (
                      <Data_Table
                        tableData={Details.openItemsList}
                        title="Open Items List"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Customer Details Section */}
            <CustomerDetails
              Details={Details}
              refetchDetails={fetchdetails}
              onOpenPurchaseModal={() => setShowPurchaseModal(true)}
              onOpenProformaModal={() => setShowProformaModal(true)}
              onOpenServiceModal={() => setShowServiceModal(true)}
              onOpenInteractionModal={() => setShowInteractionModal(true)}
            />

            <UserFooter />
          </div>
        </div>
      </div>

      <QuickEmailModal
        isOpen={showEmailModal}
        onClose={() => setShowEmailModal(false)}
        contact={profile}
        contactType="Customer"
      />
      <CreateInteractionRecordModal
        open={showInteractionModal}
        onClose={() => setShowInteractionModal(false)}
        customerId={id}
        onInteractionCreated={(record) => {
          setShowInteractionModal(false);
          fetchdetails();
        }}
      />
      <CreateServiceRequestModal
        open={showServiceModal}
        onClose={() => setShowServiceModal(false)}
        leadId={id}
        customerId={id}
        onServiceCreated={(record) => {
          setShowServiceModal(false);
          fetchdetails();
        }}
      />
      <CreatePurchaseModal
        open={showPurchaseModal}
        onClose={() => setShowPurchaseModal(false)}
        customerId={id}
        onPurchaseCreated={(record) => {
          setShowPurchaseModal(false);
          fetchdetails();
        }}
      />
      <CreateProformaModal
        open={showProformaModal}
        onClose={() => setShowProformaModal(false)}
        customerId={id}
        onProformaCreated={(record) => {
          setShowProformaModal(false);
          fetchdetails();
        }}
      />
    </>
  );
}